import { createSelector } from 'reselect';
import { RootState } from 'ReduxTypes';

export const selectCart = (state: RootState) => state.cart;

export const selectUserCart = createSelector(
  selectCart,
  (cart) => cart.userCart,
);
